module.exports = new __parcel__URL__("PageInsightsGraphDark.201ed636.svg").toString();